import api from './api';

export const getPrinterDashboard = async () => {
  return api.post('/api/Printer/Dashboard', {});
};

export const getPrinterEvents = async (printerGuid, take = 100) => {
  return api.post('/api/Printer/Events', { printerGuid, take });
};

export const createPrinter = async (payload) => {
  return api.post('/api/Printer/Create', payload);
};

export const updatePrinter = async (payload) => {
  return api.post('/api/Printer/Update', payload);
};

export const deletePrinter = async (guid) => {
  return api.post('/api/Printer/Delete', { guid });
};

export const createAssignment = async (payload) => {
  return api.post('/api/Printer/CreateAssignment', payload);
};

export const updateAssignment = async (payload) => {
  return api.post('/api/Printer/UpdateAssignment', payload);
};

export const deleteAssignment = async (guid) => {
  return api.post('/api/Printer/DeleteAssignment', { guid });
};

export const createPrinterEvent = async (payload) => {
  return api.post('/api/Printer/CreateEvent', payload);
};

export const getPrinterCatalogs = async () => {
  return api.post('/api/Printer/Catalog/List', {});
};

export const createPrinterCatalog = async (payload) => {
  return api.post('/api/Printer/Catalog/Create', payload);
};

export const updatePrinterCatalog = async (payload) => {
  return api.post('/api/Printer/Catalog/Update', payload);
};

export const deletePrinterCatalog = async (guid) => {
  return api.post('/api/Printer/Catalog/Delete', { guid });
};

export const getTonerStocks = async () => {
  return api.post('/api/Printer/TonerStock/List', {});
};

export const createTonerStock = async (payload) => {
  return api.post('/api/Printer/TonerStock/Create', payload);
};

export const updateTonerStock = async (payload) => {
  return api.post('/api/Printer/TonerStock/Update', payload);
};

export const deleteTonerStock = async (guid) => {
  return api.post('/api/Printer/TonerStock/Delete', { guid });
};
